import { render, staticRenderFns } from "./FollowupsTableFilters.vue?vue&type=template&id=75473e3b&scoped=true&"
import script from "./FollowupsTableFilters.vue?vue&type=script&lang=js&"
export * from "./FollowupsTableFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75473e3b",
  null
  
)

export default component.exports